export const Categories = [
  {
    id: 'case_introduction',
    parentLabel: 'Case Introduction',
    label: 'Case Introduction',
    imgSrc: 'https://assets.languify.in/images/caseIntro.png',
    score: 50,
    description: 'Evaluates your ability to understand the case context, identify key issues, and articulate relevant questions',
    subCategories: [
      {
        id: 'RELEVANCE',
        label: 'Relevance',
        weightage: 33.33,
        description: 'The ability to logically deconstruct the problem and devise a step-by-step, efficient solution while considering all given constraints.'
      },
      {
        id: 'DEPTH',
        label: 'Depth',
        weightage: 33.33,
        description: 'The depth of understanding and analysis demonstrated in the case introduction.'
      },
      {
        id: 'CLARITY',
        label: 'Clarity',
        weightage: 33.34,
        description: 'The clarity and coherence in explaining thought processes and logic.'
      }
    ]
  },
  {
    id: 'hypothesis_framework',
    label: 'Hypothesis Framework',
    imgSrc: 'https://assets.languify.in/images/coreConcepts.png',
    description: 'Assesses your ability to develop structured hypotheses and create logical frameworks for problem-solving',
    subCategories: [
      {
        id: 'LOGIC',
        label: 'Logic',
        weightage: 50,
        description: 'The logical structure and reasoning behind the framework approach'
      },
      {
        id: 'FEASIBILITY',
        label: 'Feasibility',
        weightage: 50,
        description: 'The practicality and implementability of the proposed framework'
      }
    ]
  },
  {
    id: 'data_analysis',
    label: 'Data Analysis',
    imgSrc: 'https://assets.languify.in/images/dataAnalysis.png',
    description: 'Measures your capability to interpret data, perform calculations, and derive meaningful insights',
    subCategories: [
      {
        id: 'PRECISION',
        label: 'Precision',
        weightage: 33.33,
        description: 'Accuracy and correctness in data analysis and calculations'
      },
      {
        id: 'INSIGHTFULNESS',
        label: 'Insightfulness',
        weightage: 33.33,
        description: 'Depth and quality of insights derived from data analysis'
      },
      {
        id: 'THOROUGHNESS',
        label: 'Thoroughness',
        weightage: 33.34,
        description: 'Completeness and comprehensiveness of the data analysis'
      }
    ]
  },
  {
    id: 'hypothesis_testing',
    label: 'Hypothesis Testing',
    imgSrc: 'https://assets.languify.in/images/hypothesisTesting.png',
    description: 'Evaluates your approach to validating hypotheses, identifying risks, and ensuring practical applicability',
    subCategories: [
      {
        id: 'VALIDATION',
        label: 'Validation',
        weightage: 33.33,
        description: 'Rigor and thoroughness in testing and validating hypotheses'
      },
      {
        id: 'MITIGATION',
        label: 'Mitigation',
        weightage: 33.33,
        description: 'Ability to address potential issues and risks in hypothesis testing'
      },
      {
        id: 'PRACTICALITY',
        label: 'Practicality',
        weightage: 33.34,
        description: 'Practical feasibility and real-world applicability of the testing approach'
      }
    ]
  },
  {
    id: 'conclusion',
    label: 'Conclusion',
    imgSrc: 'https://assets.languify.in/images/conclusion.png',
    description: 'Assesses your ability to synthesize findings into actionable recommendations aligned with strategic goals',
    subCategories: [
      {
        id: 'ACTIONABILITY',
        label: 'Actionability',
        weightage: 50,
        description: 'The extent to which recommendations are specific, implementable, and actionable'
      },
      {
        id: 'STRATEGIC_ALIGNMENT',
        label: 'Strategic Alignment',
        weightage: 50,
        description: 'How well the conclusions align with strategic business objectives and priorities'
      }
    ]
  },
  {
    id: 'speech',
    label: 'Speech',
    imgSrc: 'https://assets.languify.in/images/speech4c.png',
    description: 'Ability to articulate thoughts clearly and effectively',
    subCategories: [
      {
        id: 'FLUENCY',
        label: 'Fluency',
        weightage: 50,
        description: 'Ability to speak smoothly, with clear, continuous flow, and minimal pauses or disruptions'
      },
      {
        id: 'DELIVERY',
        label: 'Delivery',
        weightage: 50,
        description: 'How someone talks, focusing on how fast they speak & their energy level'
      }
    ]
  }
];

export const SubCategoryWeightages = [
  { subCategory: 'RELEVANCE', weightage: 6.67 },
  { subCategory: 'DEPTH', weightage: 6.67 },
  { subCategory: 'CLARITY', weightage: 6.66 },
  { subCategory: 'LOGIC', weightage: 12.5 },
  { subCategory: 'FEASIBILITY', weightage: 12.5 },
  { subCategory: 'PRECISION', weightage: 8.33 },
  { subCategory: 'INSIGHTFULNESS', weightage: 8.33 },
  { subCategory: 'THOROUGHNESS', weightage: 8.34 },
  { subCategory: 'VALIDATION', weightage: 5 },
  { subCategory: 'MITIGATION', weightage: 5 },
  { subCategory: 'PRACTICALITY', weightage: 5 },
  { subCategory: 'ACTIONABILITY', weightage: 7.5 },
  { subCategory: 'STRATEGIC_ALIGNMENT', weightage: 7.5 },
  { subCategory: 'FLUENCY', weightage: 2.5 },
  { subCategory: 'DELIVERY', weightage: 2.5 }
];

